import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6075b0a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "box-title" }
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = { class: "high-light" }
const _hoisted_8 = {
  class: "high-light",
  style: { color: '#000' }
}
const _hoisted_9 = {
  class: "high-light",
  style: { color: 'blue' }
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_11 = { class: "high-light" }
const _hoisted_12 = { class: "high-light" }
const _hoisted_13 = { class: "high-light" }
const _hoisted_14 = { class: "high-light" }

import { ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Overlay, Loading } from "vant";
import createWatermark from "@/utils/watermark";
import dayjs, { Dayjs } from "dayjs";
import { numToMoney } from "@/utils";

import request from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  __name: 'CentralAreaRemunerationBP',
  setup(__props) {

const route = useRoute();

const visible = ref(false);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: `/api/wx/invoice/list-center-returned-bp`,
    method: "POST",
    data: {
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(pageData.value.time).format("YYYY-MM-DD")), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (oneDept, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(oneDept.oneDept), 1),
              _createVNode(_unref(Cell), {
                "title-style": { width: '200px', flex: 'inherit' },
                size: "large",
                title: "截至推送时间累积总应收：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(numToMoney)(oneDept?.upToNowReceivableAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Cell), {
                size: "large",
                title: `${oneDept.oneDept}总应收：`,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(numToMoney)(oneDept.receivableAmount)), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "本年度累计开票：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(numToMoney)(oneDept.currYearInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "本年度累计回款：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(numToMoney)(oneDept.currYearReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              _hoisted_10,
              _createVNode(_unref(Cell), {
                size: "large",
                border: false,
                title: "当天开票总计：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(numToMoney)(oneDept.todayInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.todayDeptInvoiceList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: 
                index !== oneDept.todayDeptInvoiceList.length - 1 ? false : true
              ,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.invoicePrice)
                }, null, 8, ["border", "title", "value"]))
              }), 128)),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "当天回款总计：",
                border: false,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(numToMoney)(oneDept.todayReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.todayDeptReturnedList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: 
                index !== oneDept.todayDeptReturnedList.length - 1
                  ? false
                  : true
              ,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.returnedAmount)
                }, null, 8, ["border", "title", "value"]))
              }), 128)),
              _createVNode(_unref(Cell), {
                size: "large",
                border: false,
                title: "当月开票总计：",
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(numToMoney)(oneDept.currMonthInvoiceAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.currMonthDeptInvoiceList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: 
                index !== oneDept.currMonthDeptInvoiceList.length - 1
                  ? false
                  : true
              ,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.invoicePrice)
                }, null, 8, ["border", "title", "value"]))
              }), 128)),
              _createVNode(_unref(Cell), {
                size: "large",
                title: "当月回款总计：",
                border: false,
                class: "bold"
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(numToMoney)(oneDept.currMonthReturnedAmount)), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDept.currMonthDeptReturnedList, (twoDetp, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  key: index,
                  "title-style": { color: '#666666' },
                  border: 
                index !== oneDept.currMonthDeptReturnedList.length - 1
                  ? false
                  : true
              ,
                  title: `${twoDetp.twoDept}：`,
                  value: _unref(numToMoney)(twoDetp.returnedAmount)
                }, null, 8, ["border", "title", "value"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ], 512), [
        [_vShow, pageData.value?.length]
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})